var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"main pt-0"},[_c('MessageBox',{attrs:{"props":_vm.snackbar}}),_c('Appbar',{attrs:{"scroll":_vm.scrollPosition,"open-appointment-window":function () {
          this$1.$refs.rview.openAppointmentWindow();
        }}}),_c('router-view',{ref:"rview",attrs:{"snackbar":_vm.snackbar,"scroll":_vm.scrollPosition}}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }